import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

function BackButton({ to, href, onClick, className, style, "aria-label": ariaLabel }) {
  const baseStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: 32,
    height: 32,
    padding: 0,
    background: "var(--gray-3, #E4E4E4)",
    borderRadius: 1000,
    border: "none",
    cursor: to || href || onClick ? "pointer" : "default",
    textDecoration: "none",
    flexShrink: 0,
  };

  const iconStyle = {
    width: 20,
    height: 20,
    color: "var(--gray-9, #222222)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
  };

  const content = <i className="fas fa-arrow-left" style={iconStyle} aria-hidden />;

  const combinedStyle = style ? { ...baseStyle, ...style } : baseStyle;

  if (to) {
    return (
      <Link
        to={to}
        className={className}
        style={combinedStyle}
        onClick={onClick}
        aria-label={ariaLabel || "Voltar"}
      >
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={className}
        style={combinedStyle}
        onClick={onClick}
        aria-label={ariaLabel || "Voltar"}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={className}
      style={combinedStyle}
      onClick={onClick}
      aria-label={ariaLabel || "Voltar"}
    >
      {content}
    </button>
  );
}

BackButton.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  "aria-label": PropTypes.string,
};

export default BackButton;
